<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 17 17"
		role="presentation"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill="currentColor"
			d="M5,0 C5.55228475,0 6,0.44771525 6,1 C6,1.51283584 5.61395981,1.93550716 5.11662113,1.99327227 L5,2 L3,2 C2.48716416,2 2.06449284,2.38604019 2.00672773,2.88337887 L2,3 L2,14 C2,14.5128358 2.38604019,14.9355072 2.88337887,14.9932723 L3,15 L14,15 C14.5128358,15 14.9355072,14.6139598 14.9932723,14.1166211 L15,14 L15,12 C15,11.4477153 15.4477153,11 16,11 C16.5128358,11 16.9355072,11.3860402 16.9932723,11.8833789 L17,12 L17,14 C17,15.5976809 15.75108,16.9036609 14.1762728,16.9949073 L14,17 L3,17 C1.40231912,17 0.0963391206,15.75108 0.00509269341,14.1762728 L0,14 L0,3 C0,1.40231912 1.24891996,0.0963391206 2.82372721,0.00509269341 L3,0 L5,0 Z"
		></path>
		<path
			fill="#FF3D37"
			d="M9.75380963,0.00685022022 L9.87255402,0 L15.9817934,0 L16.0584018,0.00283862041 L16.0584018,0.00283862041 L16.1869807,0.0207734521 L16.1869807,0.0207734521 L16.2764478,0.0433459088 L16.2764478,0.0433459088 L16.4129031,0.0954641732 L16.4129031,0.0954641732 L16.5108497,0.147962587 L16.5108497,0.147962587 L16.5745797,0.190252813 L16.5745797,0.190252813 L16.6143232,0.22018179 L16.6143232,0.22018179 L16.7017742,0.298225799 C16.7378127,0.334264256 16.7705849,0.372332095 16.8000908,0.412061463 L16.873059,0.525331362 L16.873059,0.525331362 L16.9233812,0.63000788 L16.9233812,0.63000788 L16.9612349,0.739254473 L16.9612349,0.739254473 L16.9844502,0.840372491 L16.9844502,0.840372491 L16.9982216,0.957867522 L16.9982216,0.957867522 L17,1.01820657 L17,7.12744598 C17,7.68978594 16.5441334,8.14565254 15.9817934,8.14565254 C15.4596206,8.14565254 15.0292539,7.75258389 14.9704371,7.24619037 L14.9635869,7.12744598 L14.9632724,3.47615722 L7.73818734,10.7017742 C7.34055294,11.0994086 6.6958602,11.0994086 6.2982258,10.7017742 C5.93117866,10.3347271 5.90294427,9.75716868 6.21352261,9.35773519 L6.2982258,9.26181266 L13.5225101,2.03641314 L9.87255402,2.03641314 C9.3503812,2.03641314 8.92001449,1.64334448 8.86119768,1.13695096 L8.85434746,1.01820657 C8.85434746,0.496033748 9.24741611,0.0656670326 9.75380963,0.00685022022 Z"
		></path>
	</svg>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			ddefault: "",
		},
		width: {
			type: Number,
			default: 17,
		},
		height: {
			type: Number,
			default: 17,
		},
		fill: {
			type: String,
			default: "#000",
		},
	},
};
</script>

<style scoped>
path {
	transition: all 0.3s;
}
</style>
